export const STORE_LOCATOR_URLS = {
  en_at:  '//www.dior.com/fashion/stores/en_at/search',
  nl_be:  '//www.dior.com/fashion/stores/nl_be/search',
  fr_be:  '//www.dior.com/fashion/stores/fr_be/search',
  en_bg:  '//www.dior.com/fashion/stores/en_bg/search',
  en_hr:  '//www.dior.com/fashion/stores/en_hr/search',
  en_cy:  '//www.dior.com/fashion/stores/en_cy/search',
  en_dk:  '//www.dior.com/fashion/stores/en_dk/search',
  de_de:  '//www.dior.com/fashion/stores/de_de/search',
  es_es:  '//www.dior.com/fashion/stores/es_es/search',
  en_ee:  '//www.dior.com/fashion/stores/en_ee/search',
  en_fi:  '//www.dior.com/fashion/stores/en_fi/search',
  fr_fr:  '//www.dior.com/fashion/stores/fr_fr/search',
  en_gr:  '//www.dior.com/fashion/stores/en_gr/search',
  en_hu:  '//www.dior.com/fashion/stores/en_hu/search',
  en_ie:  '//www.dior.com/fashion/stores/en_ie/search',
  it_it:  '//www.dior.com/fashion/stores/it_it/search',
  en_lt:  '//www.dior.com/fashion/stores/en_lt/search',
  en_lv:  '//www.dior.com/fashion/stores/en_lv/search',
  nl_nl:  '//www.dior.com/fashion/stores/nl_nl/search',
  ru_ru:  '//www.dior.com/fashion/stores/ru_ru/search',
  en_pl:  '//www.dior.com/fashion/stores/en_pl/search',
  en_pt:  '//www.dior.com/fashion/stores/en_pt/search',
  en_ro:  '//www.dior.com/fashion/stores/en_ro/search',
  en_sk:  '//www.dior.com/fashion/stores/en_sk/search',
  en_si:  '//www.dior.com/fashion/stores/en_si/search',
  en_se:  '//www.dior.com/fashion/stores/en_se/search',
  en_ch:  '//www.dior.com/fashion/stores/en_ch/search',
  en_gb:  '//www.dior.com/fashion/stores/en_gb/search',
  en_ca:  '//www.dior.com/fashion/stores/en_ca/search',
  fr_ca:  '//www.dior.com/fashion/stores/fr_ca/search',
  en_us:  '//www.dior.com/fashion/stores/en_us/search',
  pt_br:  '//www.dior.com/fashion/stores/pt_br/search',
  es_sam:  '//www.dior.com/fashion/stores/es_sam/search',
  en_ae:  '//www.dior.com/fashion/stores/en_ae/search',
  en_au:  '//www.dior.com/fashion/stores/en_au/search',
  zh_cn:  '//www.dior.cn/fashion/stores/zh_cn/search',
  zh_hk:  '//www.dior.com/fashion/stores/zh_hk/search',
  en_hk:  '//www.dior.com/fashion/stores/en_hk/search',
  zh_tw:  '//www.dior.com/fashion/stores/zh_tw/search',
  ja_jp:  '//www.dior.com/fashion/stores/ja_jp/search',
  ko_kr:  '//www.dior.com/fashion/stores/ko_kr/search',
  en_int:  '//www.dior.com/fashion/stores/en_int/search',
  en_sg:  '//www.dior.com/fashion/stores/en_sg/search',
  en_my:  '//www.dior.com/fashion/stores/en_my/search',
  en_th:  '//www.dior.com/fashion/stores/en_th/search',
  en_vn:  '//www.dior.com/fashion/stores/en_vn/search',
};


// WEBPACK FOOTER //
// ./src/settings/yext.js